import { Skeleton } from "@atlant/ui"

import { MonthCard, type MonthSummary } from "./month-card.tsx"

interface MonthGridProps {
  slug: string
  year: number
  aircraftId?: string
  summaries: MonthSummary[]
  isLoading: boolean
}

export const MonthGrid = ({
  slug,
  year,
  aircraftId,
  summaries,
  isLoading,
}: MonthGridProps) => {
  const byMonth = new Map(summaries.map((summary) => [summary.month, summary]))

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: 12 }, (_, i) => i + 1).map((month) =>
        isLoading ? (
          <Skeleton key={month} className="h-42 rounded-lg" />
        ) : (
          <MonthCard
            key={month}
            slug={slug}
            year={year}
            month={month}
            aircraftId={aircraftId}
            summary={byMonth.get(month)}
          />
        ),
      )}
    </div>
  )
}
